<template>
  <div>
    <Header :loginState="loginState" @changeSuspendState="changeSuspendState"
    @changeLoginState="changeLoginState" @changeSuspendType="changeSuspendType"></Header>
    <div class="information-bg"></div>
    <div class="information-content-body">
      <div class="information-left-body">
        <h4 class="information-h4">
          <ul class="information-h4-ul">
              <li v-for="(item, index) in newsTabList" class="information-h4-li" 
              :class="{ informationH4LiActive: newsDirector == index }"
               :key="index" @click="selectInformationType(index)">
                  <span >{{ item.title }}</span>
              </li>
          </ul>
        </h4>
        <div class="all-information-body">
          <div class="all-information-item" v-for="(item,index) in allInformationList" :key="index"
          @click="enterInformationDetails(item.information_id,item.information_type)">
            <div class="all-information-pic">
              <img :src="item.information_url == undefined ? baseImageAddress + 'type=news&game_tag=platform' : baseAddress+item.information_url" v-show="item.information_type == 8">
              <img :src="baseImageAddress+'type=news&game_tag='+item.game_tag" v-show="item.information_type != 8">
              <i class="all-information-icon" v-show="infomrationBean.page == 1"></i>
            </div>
            <div class="all-information-content">
              <div class="all-information-title">
                <span class="all-information-tab news-xw" v-if="item.information_type == 1">新闻</span>
                <span class="all-information-tab news-gg" v-if="item.information_type == 2">公告</span>
                <span class="all-information-tab news-hd" v-if="item.information_type == 3">活动</span>
                <span class="all-information-tab news-gl" v-if="item.information_type == 6">攻略</span>
                <span class="all-information-tab news-gg" v-if="item.information_type == 8">公告</span>
                <span class="all-information-h1">{{item.information_title}}</span>
              </div>
              <p>{{unescapeHTML(item.information_content)}}</p>
              <span class="all-information-time">{{new Date(item.information_time).Format("yyyy-MM-dd hh:mm")  }}</span>
            </div>
          </div>
          <CommonPage v-show="!showPageState" class="center-game-page" style="margin-bottom: 0;width: 100%;margin-top: 25px;"
           :current.sync='infomrationBean.page' :page-size="infomrationBean.row" :total="informationTotal" show-total show-elevator @on-change="selectPage" prev-text="上一页" next-text="下一页"/>
        </div>
      </div>
      <RecommendSide></RecommendSide>
    </div>
    <Footer></Footer>
    <SuspendSide></SuspendSide>
    <SuspendMember :suspendType="suspendType" :suspendState="suspendState"
    @changeSuspendState="changeSuspendState" @changeSuspendType="changeSuspendType"
    @changeLoginState="changeLoginState"></SuspendMember>
  </div>
</template>
<script>
  import Footer from '../../components/common/Footer';
  import Header from '../../components/common/Header';
  import RecommendSide from '../../components/RecommendSide';
  import SuspendSide from '../../components/SuspendSide';
  import SuspendMember from '../../components/SuspendMember';
  import CommonPage from '../../components/CommonPage';
  export default {
    metaInfo(){
      return {
        title:"资讯中心_"+this.$store.state.home.title,
        meta:[
          { name:'keywords', content:this.$store.state.home.keywords},
          { name:'description',content:this.$store.state.home.description}
        ]
      }
    },
    computed:{
      allInformationList:{
        get(){
          return this.$store.state.information.allInformationList
        },
        set(value){
          this.$store.state.information.allInformationList = value;
        }    
      },
      informationTotal:{
        get(){
          return this.$store.state.information.informationTotal;
        },
        set(value){
          this.$store.state.information.informationTotal = value;
        }   
      },
      showPageState:{
        get(){
          return this.$store.state.information.showPageState;
        },
        set(value){
          this.$store.state.information.showPageState = value;
        }
      },
      baseImageAddress(){
        return this.$store.state.constant.baseImageAddress;
      },
      baseAddress(){
        return this.$store.state.constant.baseAddress;
      }
    },
    asyncData({store,route}){
      return store.dispatch('initInformation',{store:store});
    },
    data(){
      return{
        infomrationBean:{
          type:0,
          page:1,
          row:6
        },
        newsDirector:0,
        newsTabList:[
          {id:'1',title:'全部'},
          {id:'2',title:'新闻'},
          {id:'3',title:'公告'},
          {id:'4',title:'活动'},
        ],
        suspendState:false,
        suspendType:0,
        loginState:false,
      }
    },
    components:{ Footer, Header, RecommendSide, SuspendSide, SuspendMember, CommonPage},
    mounted(){
      let type = this.$route.query.index;
      if(type != undefined){
        this.selectInformationType(type);
      }else{
        this.selectInformationType(0);
      }
    },
    methods: {
      changeSuspendState(value){
        this.suspendState = value;
      },
      changeSuspendType(value){
        this.suspendType = value;
      },
      changeLoginState(value){
        this.loginState = value;
      },
      enterInformationDetails(value,type){
        if(type == 8){
          window.open(this.$router.resolve({name: "informationNotice",query:{news_id:value}}).href,'_blank');
        }else{
          window.open(this.$router.resolve({name: "informationDetails",query:{news_id:value}}).href,'_blank');
        }
      },
      queryAllNews(){
        this.$http.get(`/query_all_news`,{params:this.infomrationBean}).then(res=>{
          if (res.data.code == 2000) {
            this.allInformationList=res.data.data
            this.informationTotal = res.data.total
            if(this.informationTotal < 6){
              this.showPageState = true;
            }else{
              this.showPageState = false;
            }
          }else{
            this.showPageState = true;
            this.allInformationList = [];
            this.informationTotal = 0;
          }
        });
      },  
      selectPage(value){
        this.infomrationBean.page=value;
        this.queryAllNews();
      },
      selectInformationType(value){
        this.newsDirector =value;
        this.infomrationBean.type=value;
        this.infomrationBean.page=1;
        this.queryAllNews();
      },
      unescapeHTML(value){
        let content = value;
        if(value != undefined){
          var reg = new RegExp('&nbsp;','g');
          content = content.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'')
          .replace(/\s*/g,"")
          .replace(/[\r\n]/g,"");
          var arrEntities = {'lt':'<','gt':'>','nbsp':' ','amp':'&','quot':'"'};
          content = content.replace(/&(lt|gt|nbsp|amp|quot);/ig,function(all,t){
            return arrEntities[t];
          });
          content = content.replace(/<[^>]+>/g,"")
          .replace(new RegExp('&nbsp;','g'),"")
          .replace(new RegExp('&ldquo;','g'),"")
          .replace(new RegExp('&rdquo;','g'),"")
          .replace(new RegExp('&mdash;','g'),"")
          .replace(new RegExp('&Oslash;','g'),"")
          .replace(new RegExp('&middot;','g'),"");
          if(content.length > 80){
            content = content.slice(0,80)+'...';
          }
          return content;
        }
        return '';
      },
    },   
  }
</script>
<style src="@/assets/css/information/information.css" scoped></style>